export default "/directory/static/digital_editing_included.c5c230b6.svg";